const htmlTemplate = `<ul class="list-inline list-practice-area margin-b0" ng-init="hmLimitGiven = hmLimit; hmFilteredObjectArray = (hmObjectArray | filter: hmFilter); hmLength =hmFilteredObjectArray.length">
<li ng-if="hmStyle" class="label label-info text-uppercase margin-r5" ng-repeat="object in hmFilteredObjectArray | limitTo:hmLimitGiven track by $index" ng-style="{{styles}}">
  {{(hmProperty !== UNDEFINED && hmProperty !== NULL) ? object[hmProperty] :object}} &nbsp;
</li>

 <li ng-if="!hmStyle" ng-repeat="object in hmFilteredObjectArray | limitTo:hmLimitGiven track by $index">
     {{(hmProperty !== UNDEFINED && hmProperty !== NULL) ? object[hmProperty] :object}}
     <span ng-if="!$last">,  </span>
 </li>

&nbsp;
<div ng-repeat-end="" class="more-less-text display-inline padding-5">
  <a ng-if="hmLimitGiven < hmLength" ng-click="displayMoreObjects();" class="text-info pointer">{{hmLength - hmLimit}}&nbsp;{{hmMoreText}}</a>
  <a ng-if="hmLimitGiven === (hmLength + 1)" ng-click="displayLessObjects();" class="text-info pointer"> &nbsp;{{hmLessText}}</a>
</div>
</ul>`

angular.module('app.directives').directive('seeMore', function seeMore() {
  return {
    scope: {
      hmStyle: '@',
      hmLimit: '@',
      hmObjectArray: '=',
      hmMoreText: '@',
      hmLessText: '@',
      hmMoreClass: '@',
      hmLessClass: '@',
      hmFilter: '=',
      hmProperty: '@',
    },
    replace: true,
    template: htmlTemplate,
    controller: function($scope) {
      const getStyles = () => {
        if (!_.isEmpty($scope.hmStyle)) {
          return $scope.hmStyle.replace('this', 'object')
        }

        return {}
      }

      $scope.styles = getStyles($scope.hmStyle)

      $scope.displayMoreObjects = () => {
        $scope.hmLimitGiven = $scope.hmLength + 1
      }

      $scope.displayLessObjects = () => {
        $scope.hmLimitGiven = $scope.hmLimit
      }
    },
  }
})



// WEBPACK FOOTER //
// ./scripts/shared/directives/see-more.js